@let appearance = $appearance();

@if ($showInstallButton()) {
  <button
    tuiButton
    type="button"
    size="s"
    class="w-full button-bg-inverse"
    [appearance]="appearance"
    (click)="onInstallPwa(iosPwaInstructions)"
    [ngClass]="{
      'border! border-(--x-color-gray-50)! border-solid!':
        appearance === 'floating',
    }"
  >
    <span class="x-font-body-4 font-semibold! x-text-dark-main">{{
      'core.pwa.install_app_btn' | translate
    }}</span>
  </button>
}

<ng-template #iosPwaInstructions let-observer>
  <div class="x-text-dark-main">
    <h2 class="x-font-body-2-bold mb-2">
      {{ 'core.pwa.install_app_instructions_title' | translate }}
    </h2>
    <div class="x-font-body-3 mb-2">
      <b>1.</b> {{ 'core.pwa.install_app_instructions_step1' | translate }}
    </div>
    <div class="x-font-body-3 mb-2">
      <b>2.</b> {{ 'core.pwa.install_app_instructions_step2' | translate }}
    </div>
    <div class="x-font-body-3 mb-2">
      <b>3.</b> {{ 'core.pwa.install_app_instructions_step3' | translate }}
    </div>
    <div class="x-font-body-3 mb-4">
      <b>4.</b> {{ 'core.pwa.install_app_instructions_step4' | translate }}
    </div>
    <button
      tuiButton
      size="s"
      appearance="primary"
      class="w-full"
      (click)="observer.complete()"
    >
      <span class="x-font-body-2-bold"> OK </span>
    </button>
  </div>
</ng-template>
